import React from "react"
import { Router } from "@reach/router"

import "./App.css"

import Landing from "./pages/Landing"
import Programming from "./pages/Programming"
import Creative from "./pages/Creative"

function App() {
    console.log('Your process.env.PUBLIC_URL', process.env.PUBLIC_URL)
    return (
        <div className="App">
            <Router>
                <Landing path="/" />
                <Programming path="/programming" />
                <Creative path="/creative" />
            </Router>
        </div>
    )
}

export default App
